export const toSeconds = (milliseconds: number) =>
  +Math.floor((milliseconds / 1000) % 60).toFixed();
